<template>
    <Intro :labelAndDescColor="customColor"/>
    <NursingHelpline />
    <NursingHelplineDesc :text="'Minor illnesses or injuries'"/>
    <NursingHelplineDesc :text="'Routine health issues'"/>
    <NursingHelplineDesc :text="'Medication advice'"/>
    <NursingHelplineDesc :text="'Diet and fitness advice'"/>
    <NursingHelplineDesc :text="'Men, women, elderly, newborn and children\'s health'"/>
    <NursingHelplineDesc :text="'Pre & Post Surgery Counselling'"/>
    <p style="margin-left: 20%;" class="font-jost mb-24 text-xl">* The medical helpline will be operated during Monday to Friday from 6pm to 9am and full day on Saturdays, Sundays and public holidays</p>
    <NursingMedicalConcierge :contentColor="customContentColor"/>
    <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/nursing/NursingIntro.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";
import NursingHelpline from "@/components/nursing/NursingHelpline.vue";
import NursingHelplineDesc from "@/components/nursing/NursingStarDesc.vue";
import NursingMedicalConcierge from "@/components/nursing/NursingMedicalConcierge.vue";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const commonStore = useCommonStore();

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});

const customColor = computed(() => {
  return route.meta.color || '#82488F';
});

const customContentColor = computed(() => {
  if (route.name == 'patinursingservices')
    return '#488F82';
  else 
    return '#82488F';
})
</script>